// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuex from "vuex";
import App from "./App";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import VueFlex from "vue-flex";
import Vuetify from "vuetify";
import jQuery from "jquery";
import moment from "moment";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsCoordinates from "highcharts/modules/parallel-coordinates";
import Exporting from "highcharts/modules/exporting";
import Drilldown from "highcharts/modules/drilldown";
import NoData from "highcharts/modules/no-data-to-display";
import Ammap3 from "ammap3";
import Ammap3World from "ammap3/ammap/maps/js/worldLow";
import Ammap3Theme from "ammap3/ammap/themes/light";
import VueQueryBuilder from "vue-query-builder";
import * as d3 from "d3";
import d3Tip from "d3-tip";
import c3 from "c3";
import { store } from "@/vuex/store.js";
import select2 from "select2";
import axios from "axios";
import draggable from "vuedraggable";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import { EventBus } from "@/assets/js/event-bus.js";
import { DialogBus } from "@/smallComponents/Dialog/DialogBus";
import jstree from "jstree";
import i18n from "@/locales/i18n/i18n.js";

//css
let Bootstrap = require ("bootstrap");
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "bootstrap3/dist/css/bootstrap.min.css";
import "c3/c3.css";
import "vuetify/dist/vuetify.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "vue-flex/dist/vue-flex.css";
import "@/assets/css/loadingSpinner.css";
import "@/assets/css/bootstraps/bootstrap.css";
import "@/assets/css/queryBuilder/queryBuilder.css";
import "ammap3/ammap/plugins/export/export.css";
require ("select2/dist/css/select2.min.css");
require ("./assets/css/select2-bootstrap.css");
import "@/assets/css/custom.css";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/darwin/element_ui.scss";
import "jstree/dist/themes/default/style.min.css";
import "@/assets/css/darwin/darwin_custom.css";
import "@/sharedAssets/scss/index.scss"; // global css


// DataTable
global.jQuery = jQuery;
global.$ = jQuery;
global.jstree = jstree;

require ("@/assets/js/datatables.min.js");
require( "datatables.net-bs4" );
require( "datatables.net-select-bs4" );
require( "datatables.net-buttons-bs4" );
// require( 'datatables.net-fixedheader-dt' );
require( "datatables.net-buttons/js/buttons.html5.js" );

require( "datatables.net-bs4/css/dataTables.bootstrap4.min.css" );
require( "datatables.net-select-bs4/css/select.bootstrap4.min.css" );
require( "datatables.net-buttons-bs4/css/buttons.bootstrap4.css" );
// require( 'datatables.net-fixedheader-dt/css/fixedHeader.dataTables.css' );

require( "@/assets/js/dataTable/gyrocode/dataTables.checkboxes.js");
require( "@/assets/js/dataTable/gyrocode/dataTables.checkboxes.css");

require ("@/assets/js/pdfmake.min.js");
require ("@/assets/js/vfs_fonts.js");

require ("jquery-highlight");
require ("@/assets/js/searchHighlight/searchHighlight.js");

import qs from "qs";
import assert from "assert";

//Highcharts
HighchartsMore(Highcharts);
HighchartsCoordinates(Highcharts);
Exporting(Highcharts);
Drilldown(Highcharts);
NoData(Highcharts);
Highcharts.setOptions({
    colors: ["#7e98b0", "#f7a35c", "#90ee7e", "#7798BF", "#aaeeee", "#ff0066", "#eeaaee", "#55BF3B", "#DF5353", "#7798BF", "#aaeeee"],
});

// TreeSelect
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
Vue.component("Treeselect", Treeselect);

//Vue Use
Vue.use(BootstrapVue);
Vue.use(require("vue-moment"));
Vue.use(VueFlex);
Vue.use(ElementUI, { locale });

var mainBlue = getComputedStyle(document.documentElement).getPropertyValue("--main-color-blue");
Vue.use(Vuetify, {
    theme: {
	  primary: "#314c60",
	  secondary: "#FFE082",
	  accent: "#E91E63",
	  error: "#F44336",
	  warning: "#ffeb3b",
	  info: "#2196f3",
	  success: "#4caf50",
	  agrinome_primary: mainBlue
    }
});


//Element UI
import Element from "element-ui";
import "@/assets/config.json";
Vue.use(Element);

//dataTable variable
import { dataTableOption } from "@/assets/js/dataTable/dataTable-options.js";
import { dataTableOption_noSearch } from "@/assets/js/dataTable/dataTable-options.js";

// Vuetable
import Vuetable from "vuetable-2";
Vue.use(Vuetable);

// Agrinome Plugins
// import AgrinomeTable from '../../agrinome-table'
import AgrinomeTable from "agrinome-table";
Vue.use(AgrinomeTable);


// Vue Excel Editor Plugin
import VueExcelEditor from "vue-excel-editor";
Vue.use(VueExcelEditor);


var topojson = require ("topojson/dist/topojson.min.js");

// Set the base URL of the API
import ApiConfig from "./services/api.service.js";
import { TokenService } from "./services/storage.service";
import { PermissionService } from "./services/permission.service";

// If token exists set header
if (TokenService.getToken()) {
    ApiConfig.setHeader();
}

//Global Variable
global.ApiConfig = ApiConfig;
global.TokenService = TokenService;
global.PermissionService = PermissionService;
global.axios = axios;
global.moment = moment;
global.Highcharts = Highcharts;
global.dataTableOption = dataTableOption;
global.dataTableOption_noSearch = dataTableOption_noSearch;
global.store = store;
global.EventBus = EventBus;
global.DialogBus = DialogBus;
global.c3 = c3;
global.d3 = d3;
global.d3Tip = d3Tip;
global.topojson = topojson;
global.select2 = select2;
global.qs = qs;
global.assert = assert;

import DeleteConfirmation from "@/smallComponents/Dialog/DialogContent/DeleteConfirmation";
global.DeleteConfirmation = DeleteConfirmation;

Vue.config.productionTip = false;


// Vue.component('NavBar',require('./components/navigation-bar').default)
// Vue.component('uploadBar',require('./components/buttons/upload-bar').default)
// Vue.component('getEndPointBtn',require('./components/buttons/get-end-point-btn').default)
// Vue.component('chooseFile', require('./components/buttons/choose-file').default)
Vue.component("VueQueryBuilder", VueQueryBuilder);
Vue.component("Draggable", draggable);
Vue.component("LocalDraggable", require("./components/Configurations/CustomFormConfiguration/LocalDraggable.vue").default);
Vue.component("CustomFormInputParams", require("./components/Configurations/CustomFormConfiguration/CustomFormInputParam.vue").default);

// VueTable
Vue.component("Vuetable", require("vuetable-2/src/components/Vuetable").default);

// EventBUS component
Vue.component("AlertBar", require("./components/buttons/AlertSnackBar").default);
Vue.component("DeleteDialog", require("./components/buttons/DeleteDialog.vue").default);
Vue.component("ConfirmationDialog", require("./components/buttons/ComfirmationDialog.vue").default);

// Component
Vue.component("BunchInfo", require("@/components/FieldData/BunchInfo.vue").default);
Vue.component("CaroteneInfo", require("@/components/FieldData/CaroteneInfo.vue").default);
Vue.component("PalmLineage", require("@/components/Palm/PalmLineage.vue").default);
Vue.component("PalmLineageLarge", require("@/components/Palm/PalmLineageEnlarge.vue").default);
Vue.component("ComingSoonAnalysis", require("@/components/Analysis/ComingSoonAnalysis.vue").default);
Vue.component("PublicBase", require("@/components/Public/PublicBase.vue").default);

// Small Component
Vue.component("BackBtn", require("./smallComponents/backBtn.vue").default);
Vue.component("PreviousNavigationList", require("./smallComponents/PreviousNavigationList.vue").default);
Vue.component("ConfigurationDialog", require("./smallComponents/configurationDialog.vue").default);
Vue.component("StardardDialog", require("./smallComponents/StardardDialog.vue").default);
Vue.component("StardardDialogEdit", require("./smallComponents/StardardDialog-Edit.vue").default);
Vue.component("TraitDialog", require("./smallComponents/traitDialog.vue").default);
Vue.component("TraitDialogEdit", require("./smallComponents/traitDialog-Edit.vue").default);
Vue.component("TraitSelectForm", require("./smallComponents/TraitSelectForm.vue").default);
Vue.component("AgencyModal", require("./smallComponents/agencyModal.vue").default);
Vue.component("ConsolidationPopUp", require("./smallComponents/consolidationPopup.vue").default);
Vue.component("LoopingFormDialog", require("@/smallComponents/LoopingFormDialog.vue").default);
Vue.component("SeriesDialog", require("@/smallComponents/SeriesDialog.vue").default);
Vue.component("RecordStatus", require("@/smallComponents/RecordStatus.vue").default);
Vue.component("GeneralDialog", require("@/smallComponents/GeneralDialog.vue").default);
Vue.component("Best4ConsecutiveYear", require("@/components/Chart/Best4ConsecutiveYear.vue").default);
Vue.component("DynamicForm", require("@/smallComponents/DynamicForm.vue").default);
Vue.component("BatchUploadBrowseContainer", require("@/components/Action/BatchUploadBrowserContaniner.vue").default);
Vue.component("RawPageHeader", require("@/smallComponents/PageHeader.vue").default);
Vue.component("RecordStatusDialog", require("@/smallComponents/RecordStatusDialog.vue").default);
Vue.component("RefreshLine", require("@/smallComponents/DetailSummaryRefreshLine.vue").default);

// Form Component
Vue.component("VuetifyDropdown", require("@/smallComponents/Form/Dropdown.vue").default);
Vue.component("DatePickerInput", require("@/smallComponents/Form/DatePickerInput.vue").default);

// Raw Data
Vue.component("RawBunchData", require("@/components/Palm/PalmRawData/RawBunchDataTable").default);
Vue.component("RawCaroteneData", require("@/components/Palm/PalmRawData/RawCaroteneDataTable").default);
Vue.component("RawFattyAcidData", require("@/components/Palm/PalmRawData/RawFattyAcidDataTable").default);
Vue.component("VegetativeData", require("@/components/Palm/PalmRawData/RawVegetativeDataTable").default);
Vue.component("VitaminData", require("@/components/Palm/PalmRawData/RawVitaminDataTable").default);
Vue.component("YieldData", require("@/components/Palm/PalmRawData/RawYieldDataTable").default);
Vue.component("OtherRecording", require("@/components/Palm/PalmRawData/RawOtherRecording").default);
Vue.component("RawDataTableBase", require("@/components/Palm/PalmRawData/RawDataTableBase.vue").default);

// Derived Data
Vue.component("DerivedBunchData", require("@/components/Palm/PalmDerivedData/DerivedBunchDataTable").default);
Vue.component("DerivedCaroteneData", require("@/components/Palm/PalmDerivedData/DerivedCaroteneTable").default);
Vue.component("DerivedFattyAcidData", require("@/components/Palm/PalmDerivedData/DerivedFattyAcidTable").default);
Vue.component("DerivedVegetativeData", require("@/components/Palm/PalmDerivedData/DerivedVegetativeTable").default);
Vue.component("DerivedVitaminData", require("@/components/Palm/PalmDerivedData/DerivedVitaminTable").default);
Vue.component("DerivedYieldData", require("@/components/Palm/PalmDerivedData/DerivedYieldTable").default);

// UMS
Vue.component("RoleTable", require("@/components/UMS/TrialManagement/RoleTable.vue").default);
Vue.component("AddRole", require("@/components/UMS/TrialManagement/AddRole.vue").default);
Vue.component("UserTable", require("@/components/UMS/UserManagement/UserTable.vue").default);
Vue.component("AddUser", require("@/components/UMS/UserManagement/AddUser.vue").default);
Vue.component("AdvanceLogTable", require("@/components/UMS/AuditLog/AdvanceLogTable.vue").default);
Vue.component("SimpleLogTable", require("@/components/UMS/AuditLog/SimpleLogTable.vue").default);

// Table
Vue.component("PalmTable", require("@/components/Palm/PalmTable").default);
Vue.component("GermplasmDetail", require("@/components/Germplasm/GermplasmDetail.vue").default);
Vue.component("EditHistoryTable", require("@/components/History/RawEditHistoryTable.vue").default);

// Dashboard
Vue.component("SummaryBars", require("@/components/Dashboard/SummaryStackedBarCharts.vue").default);


// Vue Custom Directive
import SystemPermissionDirective from "@/directives/SystemPermissionDirective";

import "@/icons"; // icon

//Mixin
import mixin from "./mixin.js";
import { darwinMixin } from "@/mixin/darwin_mixin.js";
Vue.mixin(mixin);
Vue.mixin(darwinMixin);

/* eslint-disable no-new */
const vm = new Vue({
    el: "#app",
    router,
    store,
    i18n,
    components: { App },
    template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js